(function ( $ ) {
	$.fn.slider = function ( options ) {
		options = $.extend({
			interval   : 5000,				// Интервал смены слайда
			speed      : 300, 				// Скорость смены слайдов
			moveSize   : 1,					// на сколько сдвигать
			countView  : 1,					// количество видимых блоков
			classItm   : '.js-slider__itm',	// класс элемента слайда.
			mobileWidth: 700				// Ширина мобильной версии
		}, options);

		var make = function () {
			var self = this,	// перепишем объект
			    id_interval;	// id таймера

			$(document).ready(function () {
				var i,
				    move     = 0,
				    itmWidth = 0,
				    moveSize = options.moveSize;

				function init() {
					// определяем на сколько сдвигается элемент
					var selfWidth = $(self).width(),
					    is_mobile = window.matchMedia('all and (max-width: ' + options.mobileWidth + 'px)').matches;

					itmWidth = selfWidth / options.countView;

					if( is_mobile ) {
						itmWidth = selfWidth;
						moveSize = 1;
					} else {
						moveSize = options.moveSize;
					}

					move = itmWidth * moveSize;

					// Установка ширины элементов слайдера
					$(self).find(options.classItm).width(itmWidth);

					// устанавливаем ширину обертки слайдеров
					slider_main.width(count * itmWidth + 5);

					// добавление навигации
					$(self).find('.js-slider__nav').empty();

					if( is_mobile ) {
						for ( i = 0; i < count; i++ ) {
							$(self).find('.js-slider__nav').append('<a href="#" class="js-slider__nav-point"></a>');
						}
						setCurrentPoint();
					} else {
						$(self).find('.js-slider__nav').append('<a href="#" class="js-slider__prev"></a><a href="#" class="js-slider__next"></a>');
					}
				}

				// инициация слайдера
				var count = $(self).find(options.classItm).size();

				// если количество блоков меньше минимального -> уходим
				if( count <= options.countView ) return;


				// оборачиваем все элементы слайдера в блок
				$(self).find(options.classItm).wrapAll('<div class="js-slider__main"></div>');
				var slider_main = $(self).find('.js-slider__main');

				slider_main.wrap('<div class="js-slider__wrap"></div>');


				// если элементов не достатчно для сдвига, дополним
				if( count - options.countView < moveSize ) {
					for ( i = 0; i < moveSize - (count - options.countView); i++ ) {
						$(self).find(options.classItm).eq(i).clone().appendTo(slider_main);
					}

					// пересчитаем количество блоков
					count = $(self).find(options.classItm).size();
				}

				// пронумеруем для точек
				for ( i = 0; i < count; i++ ) {
					$(self).find(options.classItm).eq(i).attr('data-index', i);
				}

				$(self).append('<div class="js-slider__nav"></div>');

				init();
				$(self).find('.js-slider__nav-point').removeClass('active').first().addClass('active');

				$(window).resize(init);


				function autoSlide() {
					id_interval = setInterval(move_next, options.interval);
				}

				function setCurrentPoint() {
					var index = $(self).find(options.classItm).first(0).attr('data-index');
					$(self).find('.js-slider__nav-point').removeClass('active').eq(index).addClass('active');
				}

				// сдвиг к следующему
				function move_next() {
					clearInterval(id_interval);

					slider_main.animate(
						{'left': -move},
						options.speed,
						function () {
							for ( i = 0; i < moveSize; i++ ) {
								$(options.classItm).first().appendTo(slider_main);
							}

							slider_main.css('left', 0);
							setCurrentPoint();
							autoSlide();
						}
					);
				}

				// сдвиг к предыдущему
				function move_prev() {
					clearInterval(id_interval);

					slider_main.css('left', -move);

					for ( var i = 0; i < moveSize; i++ ) {
						$(options.classItm).last().prependTo(slider_main);
					}

					slider_main.animate({'left': 0}, options.speed, function () {
						setCurrentPoint();
						autoSlide();
					});
				}

				// обработчик на кнопку к следующим
				$(self).on('click', '.js-slider__next', function () {
					move_next();

					return false;
				});

				// обработчик на кнопку к предыдущим
				$(self).on('click', '.js-slider__prev', function () {
					move_prev();

					return false;
				});

				// Сдвиг по точкам
				$(self).on('click', '.js-slider__nav-point', function () {
					var index = $(this).index();

					if( $(this).hasClass('active') ) {
						return false;
					}

					clearInterval(id_interval);

					var need      = $(self).find(options.classItm).filter('[data-index="' + index + '"]'),
					    need_move = need.position().left;

					$(self).find('.js-slider__nav-point').removeClass('active').eq(index).addClass('active');

					slider_main.animate({'left': -need_move}, options.speed, function () {
						for ( var i = 0; i < Math.round(need_move / itmWidth); i++ ) {
							$(options.classItm).first().appendTo(slider_main);
						}

						slider_main.css('left', 0);

						autoSlide();
					});

					return false;
				});

				autoSlide();
			});

		};

		return this.each(make);
	};
})(jQuery);